import { Controller } from "react-hook-form";
import { Grid, TextField, Typography } from "@mui/material";
import { IFormField } from "models/app";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers";
import { convertTimeToISOString } from "helpers/utils";

interface Props extends IFormField {
  errors: any;
  control: any;
  required?: boolean;
  defaultValue?: any;
  onChange?: (e: any) => void;
  onReset?: (e: any) => void;
  grid?: number;
  watch?: any;
}

const RHTimePicker: React.FC<Props> = ({
  label,
  name,
  placeholder,
  disabled,
  control,
  errors,
  required,
  defaultValue,
  hidden,
  onChange,
  helperText,
  watch,
  isHorizontal,
  hideLabel
}) => {

  const newTime = '00:00:00'
  const value = watch(name) || convertTimeToISOString(defaultValue || newTime);

  const handleChange = (e: any) => onChange && onChange(e);

  return (
    <Grid display={hidden ? "none" : "block"}>
      <Grid container alignItems={"center"} hidden={hidden}>
        {!hideLabel && (
          <Grid
            item
            xs={12}
            md={label ? (!isHorizontal ? 12 : 2) : 12}
            display={"flex"}
            justifyContent={"space-between"}
          >
            {label && (
              <Typography
                variant="body2"
                fontWeight={600}
                textAlign={"start"}
                minWidth={"16ch"}
              >
                {label}
              </Typography>
            )}
          </Grid>
        )}
        <Grid item xs={12} md={label ? (!isHorizontal ? 12 : 10) : 12}>
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange, ...field } }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  disabled={disabled}
                  value={value}
                  label={hideLabel && label}
                  renderInput={(props) => (
                    <TextField
                      {...props}
                      {...field}
                      value={value || null}
                      onKeyDown={(e) => {
                        e.preventDefault()
                      }}
                      error={!!errors[name]}
                      helperText={
                        errors[name] ? `${errors[name].message}` : helperText
                      }
                      fullWidth
                      size="small"
                      sx={{
                        "& .MuiInputBase-root": {
                          borderRadius: 1,
                          px: 2,
                          bgcolor: "common.white",
                          height: 50,
                        },
                      }}
                    />
                  )}
                  onChange={(e: any) => {
                    onChange(e);
                    handleChange(e);
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RHTimePicker;
